// Util
import { treatErrorAs } from 'api/errors';

// Constants
import { errorLevel } from 'constants/errors';

import {
  findFertilityChemicalTypes,
  findFertilityStabilizers,
  findFertilizerSubstanceTypes
} from 'products/finders';

export const requestFertilityPracticesData = () => {
  return (dispatch, getState) => {
    return Promise.all([

      findFertilityChemicalTypes({ dispatch, getState, forceWait: true })
      .then( () => findFertilityStabilizers({
        dispatch,
        getState,
        onError: treatErrorAs({ severity: errorLevel.INFO })
      }) )
      .catch( treatErrorAs({ severity: errorLevel.INFO }) ),

      findFertilizerSubstanceTypes({ dispatch, getState, onError: treatErrorAs({ severity: errorLevel.INFO })})
    ]);
  };
};
